/**
 * Decodes a JWT token and returns its payload
 * @param token - The JWT token to decode
 * @returns The decoded payload or null if decoding fails
 */
export const decodeJWT = (token: string): Record<string, unknown> | null => {
    try {
        const parts = token.split('.');

        if (parts.length !== 3) {
            return null;
        }

        const payload = parts[1];

        if (!payload) {
            return null;
        }

        const paddedPayload =
            payload + '='.repeat((4 - (payload.length % 4)) % 4);
        const decodedPayload = atob(
            paddedPayload.replace(/-/g, '+').replace(/_/g, '/'),
        );

        return JSON.parse(decodedPayload);
    } catch {
        return null;
    }
};
